import { IRankingData } from "src/components/common/ranking/types";
import { MAX_ATTEMPTS, RETRY_DELAY_MS } from "src/consts/retry";
import { API_DOWNLOAD_URL, API_SEARCH_URL } from "src/consts/urls";
import { useMutation } from "src/hooks/react-query/use-mutation";
import { ISortDirectionType, IUser } from "src/types/common";

export enum EnumLeverageProductsIndication {
    AllWikifolios = 0,
    WikifoliosWithLeverageProducts = 1,
    WikifoliosWithoutLeverageProducts = 2,
}

export interface IExtendedSearchItem {
    wikifolioId: string;
    symbol: string;
    wikifolioShortDescription: string;
    trader: Pick<IUser, "id" | "firstName" | "lastName" | "nickName" | "isDeleted">;
    rankings: IRankingData[];
    isOnWatchlist?: boolean;
    isInvestable?: boolean;
}

export interface IExtendedSearchResponse {
    totalResults: number;
    results: IExtendedSearchItem[];
}

export interface IKeyFiguresRequest {
    id: string;
    min?: number;
    max?: number;
}

export interface ISearchRequestParams {
    query?: string;
    country: string;
    sortDirection?: ISortDirectionType;
    sortByRankingId?: string | null;
    offset?: number;
    tagsIds?: readonly string[];
    brokersIds?: readonly string[];
    keyFigures?: readonly IKeyFiguresRequest[];
    isInvestable?: boolean;
    isAtInvestable?: boolean;
    isChInvestable?: boolean;
    leverageProductsIndication: EnumLeverageProductsIndication;
}

export function useExtendedSearchMutation() {
    const { mutatePromise } = useMutation<IExtendedSearchResponse, unknown, ISearchRequestParams>(API_SEARCH_URL, {
        retry: MAX_ATTEMPTS,
        retryDelay: RETRY_DELAY_MS,
    });

    return mutatePromise;
}

export function useExtendedSearchDownloadMutation() {
    const { mutatePromise } = useMutation<Blob, unknown, ISearchRequestParams>(API_DOWNLOAD_URL, { accept: "text/csv" });
    return mutatePromise;
}
